import OverviewAirAmbulanceCard from './OverviewAirAmbulanceCard';
import ToolsAirAmbulanceCard from './ToolsAirAmbulanceCard';

/**
 * GMR Air ambulance card component.
 * @param {object} props
 * @param {String} props.tab - The tab where the air ambulance card is displayed.
 * @param {Function} props.handleClick - The function to be called when the card is clicked.
 */
const AirAmbulanceCard = ({ tab = '', handleClick }) => {
  const renderCard = () => {
    switch (tab) {
      case 'overview':
        return <OverviewAirAmbulanceCard onClick={handleClick} />;
      case 'tools':
        return <ToolsAirAmbulanceCard onClick={handleClick} />;
      default:
        return null;
    }
  };

  return renderCard();
};

export default AirAmbulanceCard;
